import React, { useEffect } from 'react'
import { useSetRecoilState } from 'recoil'
import { openModalState } from 'recoils/atoms'

import { Modal } from 'components'
import { getLabel } from 'helpers/language'
import iconSuccess from 'assets/svg/icon-success.svg'

interface Props {
  description: string
  isOpen: boolean
  onClose: () => void
}

export const ModalSuccess: React.FC<Props> = ({
  description = getLabel('common:success'),
  isOpen = false,
  onClose = () => {},
}: Props) => {
  const base = 'con-modal-success'
  const setIsOpenModal = useSetRecoilState(openModalState)

  useEffect(() => {
    if (isOpen) {
      setIsOpenModal(false)
    }
  }, [isOpen])

  return (
    <Modal isOpen={isOpen} onClose={onClose} isIcon={false}>
      <div className={`${base}`}>
        <div className={`${base}__icon`}>
          <img src={iconSuccess}></img>
        </div>
        <span className={`${base}__description`}>{description}</span>
      </div>
    </Modal>
  )
}

export default ModalSuccess
